/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import store from '../store'
import { performFetch } from '../../helpers'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchParameters ({ commit }) {
    return new Promise(async (resolve, reject) => {

      // fetch(`${store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_menu_builder_parameters',
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(store.state.auth.api_url, {
        command: 'get_application_menu_builder_parameters',
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token
        }
      })
      .then(async (response) => {
        if (response.status === 200) {

          response.json().then((responseData) => {

            commit('setIcons', responseData.parameters.icons)
            commit('setModules', responseData.parameters.modules)
            commit('setRoles', responseData.parameters.roles)

          })

          resolve(200)
        } else if (response.status == 401) {
          store.dispatch('auth/signOut')
          resolve(401)
        } else {
          reject(500)
        }
      })
      .catch((e) => {
        reject(500)
        // or(e.message)
      })

      // fetch(store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_users',
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token
      //     }
      //   })
      // })
      //   .then(async (response) => {
      //   // commit('SET_USERS', response.data)
      //   // resolve(response)
      //     if (response.status === 200) {
      //       await response.json().then(async (response) => {
      //         response.users.forEach((item, key) => {
      //           item.avatar = item.photo
      //           return item
      //         })
      //         response.users = response.users.filter(el => el.active === true)

      //         commit('SET_USERS', response.users)
      //         resolve(response)
      //       })
      //     } else if (response.status === 401) {
      //       setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
      //       store.dispatch('auth/signOut')
      //     }
      //   })
    })
  }
}
